import { MeetingExceptions } from './meeting_exceptions'

export const SingleHost = ({ doubleBookingRuleMembership }) => (
  <MeetingExceptions doubleBookingRuleMembership={doubleBookingRuleMembership} doubleBookingRuleMembershipIndex={0} />
)
